import { Component, computed, input, inject } from '@angular/core';
import { TableColumn } from '@ui/aos-lib';

import { TAB_VALUE } from '../listing-page/listing-page.types';
import { ListingPageService } from '../listing-page/listing-page.service';
import { TranslateModule } from '@ngx-translate/core';
import { translationKeysMap } from 'src/app/services/translate/translate.key-mapper';
import { ListingPageComponent } from '../listing-page/listing-page.component';

@Component({
  template: `
    @if (item() && column()) {
      <button
        class="ui-table__callback-btn"
        (click)="onColumnClick()"
      >
        {{ translatedValue() | translate }}
      </button>
    }
  `,
  styleUrl: './location-column.component.scss',
  imports: [TranslateModule]
})
export class LocationColumnComponent {
  private readonly pageState = inject(ListingPageService);
  private readonly listingPage = inject(ListingPageComponent);

  item = input.required<{ [key: string]: string }>();
  column = input.required<TableColumn>();

  protected translatedValue = computed(
    () => translationKeysMap.get(this.item()[this.column().field]) || this.item()[this.column().field] || ''
  );

  public onColumnClick(): void {
    this.listingPage.onTabSelected(TAB_VALUE.Map);

    const { longitude, latitude } = this.item().geoMetaData as unknown as { longitude: number; latitude: number };
    const coordinates: [number, number] = [longitude, latitude];
    const deviceIds = [this.item().deviceUID as string];

    this.pageState.onSelectedLocationChange({
      selectedLocation: {
        coordinates,
        deviceIds
      },
      sidePanelIds: []
    });
  }
}
